<template lang="pug">
.el-input.el-input--medium
  .el-input__inner(v-popover:popover)
    .input-item(v-if="isEdit")
      img(style="height: 100%", src="./assets/add.svg")
    .input-item(v-for="file in value", :key="file.fileId")
      FileIcon(:row="file", readonly)
  el-popover(ref="popover", placement="bottom-start", trigger="click", :width="400")
    .header
      span.title-label 附件列表
      el-button(v-if="uploadVm.showTemBtn", type="text", @click="uploadVm.openTemDialog") 下载模版
      .pull-right
        el-button(v-if="isEdit", type="text", @click="deleteBatch") 删除选中
        el-button(v-if="isEdit && uploadVm.useTarget", type="text", icon="el-icon-folder-checked", @click="uploadVm.setTargetFolder(uploadVm.checkedFile)") 批量位置
        el-checkbox(v-model="batchAll", v-if="isEdit", :indeterminate="indeterminate") 全选/全不选
    .file-list(:class="{ useTarget: uploadVm.useTarget }")
      label(v-for="(file, index) in fileList", :key="file.fileId", :title="file.fileName")
        input(v-show="false", v-if="isEdit", type="checkbox", v-model="checkedIds", :value="file.fileId")
        .file-item
          .file-bar(@click.prevent.stop)
            i.opt-item.el-icon-view(@click="preview(file)")
            i.opt-item.el-icon-download(v-if="file.$url", @click="download(file)")
            el-tooltip(v-if="uploadVm.useTarget", :content="file.targetFolderPath || '未配置'", placement="top")
              i.opt-item.el-icon-folder-checked(@click="uploadVm.setTargetFolder(file)")
          FileIcon(:row="value[index]", :iconSize="60", :stateSize="16", @updateLight="updateLight")
          .file-name(:class="{ 'target-err': !file.targetFolderPath }") {{ file.fileName }}
    .empty(v-if="!fileList.length") 暂无文件
    .footer
      template(v-if="isEdit")
        el-button(v-for="{ id, cnName, icon } in tools", :key="id", :icon="icon", type="text", @click="uploadVm.handleCommand(id)") {{ cnName }}
</template>
<script>
import FileIcon from "@/CommonDP/components/FileList/FileIcon.vue";
import { fileDirective } from "@/CommonDP/components/FileList/file.js";
import { downloadUrltoken } from "@/CommonDP/utils";

export default {
  directives: { file: fileDirective },
  components: { FileIcon },
  props: { value: { default: () => [], type: Array }, getVm: { default: new Function(), type: Function }},
  data() {
    return {
      checkedIds: []
    };
  },
  computed: {
    // 获取原上传组件实例,可以直接调用其数据和方法,而不要来回传值
    uploadVm() {
      return this.getVm();
    },
    tools() {
      return this.uploadVm.tools;
    },
    isEdit() {
      return this.uploadVm.isEdit;
    },
    fileList() {
      const list = this.value || [];
      return list.map((f) => ({
        ...f,
        folderId: f.fileId,
        $url: downloadUrltoken(f.prjId, f.fileId, f.version)
      }));
    },
    indeterminate() {
      const { checkedIds, fileList } = this;
      return !!checkedIds.length && fileList.some(({ fileId }) => checkedIds.indexOf(fileId) === -1);
    },
    batchAll: {
      get() {
        const { checkedIds, fileList } = this;
        return fileList.every(({ fileId }) => checkedIds.indexOf(fileId) > -1);
      },
      set(val) {
        const { fileList } = this;
        let checkedIds = [];
        if (val) checkedIds = fileList.map(({ fileId }) => fileId);
        else checkedIds = [];
        this.checkedIds = checkedIds;
      }
    }
  },
  methods: {
    updateLight(...arg) {
      this.uploadVm.updateLight(...arg);
    },
    async download(...args) {
      return this.uploadVm.downloadHandler(...args);
    },
    preview(...arg) {
      this.uploadVm.preview(...arg);
    },
    async deleteBatch() {
      const { checkedIds, uploadVm, value = [] } = this;
      if (checkedIds.length === 0) {
        this.$message.warning("请选中文件后点击删除");
        return;
      }
      const surplus = value.filter(({ fileId }) => checkedIds.indexOf(fileId) === -1);
      await this.$confirm("确定删除选中?", "警告");
      const lostList = value.splice(0, value.length, ...surplus);
      this.checkedIds = [];
      for (const file of lostList) {
        uploadVm.onFileRemove(file);
      }
      uploadVm.emitValidate();
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss">
</style>
